module.exports = "<ion-modal-view>\n  <ion-content has-bouncing=\"false\" scroll=\"false\">\n    <div class=\"vui-view\">\n      <div class=\"vui-bar vui-bar-header\">\n        <h1 class=\"vui-bar-title\">标题</h1>\n      </div>\n      <div class=\"vui-content vui-has-header\">\n        <div class=\"vui-padding\">\n          只有文案的标题栏\n          <button class=\"vui-button vui-button-original vui-button-primary vui-button-clear\" ng-click=\"hideModal(0)\">返回</button>\n        </div>\n      </div>\n    </div>\n  </ion-content>\n</ion-modal-view>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/bar/modal0.html
// module id = 5
// module chunks = 0